import { EventEmitter } from '@angular/core';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "@progress/kendo-angular-grid";
import * as i4 from "../../../common/components/app-control/app-control.component";
import * as i5 from "../../../common/components/editable-grid/editable-grid.component";
import * as i6 from "../../../common/components/info-button.component";
import * as i7 from "@ngx-translate/core";
import * as i8 from "../../../common/pipes/codelist.pipe";
function ExemptionListComponent_kendo_grid_checkbox_column_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-checkbox-column", 14);
  }
}
function ExemptionListComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 15);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_4_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r16);
      const dataItem_r14 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r14.name = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r14 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r14.name)("entity", dataItem_r14);
  }
}
function ExemptionListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 16);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_7_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r19);
      const dataItem_r17 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r17.invoiceDescription = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r17 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r17.invoiceDescription)("entity", dataItem_r17);
  }
}
function ExemptionListComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 17);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_10_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r22);
      const dataItem_r20 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r20.total = $event);
    })("ngModelChange", function ExemptionListComponent_ng_template_10_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r22);
      const dataItem_r20 = restoredCtx.dataItem;
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.resetMeasure(dataItem_r20, "percentage"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r20 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r20.total)("entity", dataItem_r20);
  }
}
function ExemptionListComponent_ng_template_11_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r24 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(2, 2, dataItem_r24.total, "1.2-2"), " ", ctx_r25.currency, "");
  }
}
function ExemptionListComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ExemptionListComponent_ng_template_11_span_0_Template, 3, 5, "span", 18);
  }
  if (rf & 2) {
    const dataItem_r24 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", dataItem_r24.total !== null);
  }
}
function ExemptionListComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 19);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_14_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r29);
      const dataItem_r27 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r27.percentage = $event);
    })("ngModelChange", function ExemptionListComponent_ng_template_14_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r29);
      const dataItem_r27 = restoredCtx.dataItem;
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.resetMeasure(dataItem_r27, "total"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r27 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r27.percentage)("entity", dataItem_r27);
  }
}
function ExemptionListComponent_ng_template_15_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r31 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, dataItem_r31.percentage, "1.2-2"), " %");
  }
}
function ExemptionListComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ExemptionListComponent_ng_template_15_span_0_Template, 3, 4, "span", 18);
  }
  if (rf & 2) {
    const dataItem_r31 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", dataItem_r31.percentage !== null);
  }
}
function ExemptionListComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_18_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r36);
      const dataItem_r34 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r34.maxPeriods = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r34 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r34.maxPeriods)("entity", dataItem_r34);
  }
}
function ExemptionListComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r37 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r37.maxPeriods, " ");
  }
}
function ExemptionListComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 21);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_22_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r40);
      const dataItem_r38 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r38.from = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r38 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r38.from)("entity", dataItem_r38)("time", true);
  }
}
function ExemptionListComponent_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_25_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r43);
      const dataItem_r41 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r41.to = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r41 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r41.to)("entity", dataItem_r41)("time", true);
  }
}
function ExemptionListComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_28_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r46);
      const dataItem_r44 = restoredCtx.$implicit;
      return i0.ɵɵresetView(dataItem_r44.active = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r44 = ctx.$implicit;
    i0.ɵɵproperty("isDisabled", true)("ngModel", dataItem_r44.active)("entity", dataItem_r44);
  }
}
function ExemptionListComponent_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 24);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_31_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r49);
      const dataItem_r47 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r47.deactivatedFrom = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r47 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r47.deactivatedFrom)("entity", dataItem_r47)("time", true);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 30);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_4_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r59);
      const dataItem_r57 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r57.typeId = $event);
    })("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_4_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r59);
      const dataItem_r57 = restoredCtx.dataItem;
      const ctx_r60 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r60.resetNames(dataItem_r57));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r57 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r57.typeId)("entity", dataItem_r57);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r61 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r61.typeId, "ExemptionType")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_8_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r64);
      const dataItem_r62 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r62.validity = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r62 = ctx.dataItem;
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("options", ctx_r53.yesNoOptions)("ngModel", dataItem_r62.validity)("entity", dataItem_r62);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r65 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r65.validity ? "Is" : "Is not", " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r81 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 44);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_0_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r81);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.cargoOperationTypeId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.cargoOperationTypeId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 45);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_1_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r85);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.countryId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.countryId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 46);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_2_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r89);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.imdgId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.imdgId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 47);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_3_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r93);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.berthId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.berthId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 48);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_4_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r97);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.organizationId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.organizationId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 49);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_5_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r101);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.permitTypeId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.permitTypeId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 50);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_6_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r105);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.callPurposeId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.callPurposeId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 51);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_7_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r109);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.vesselTypeId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.vesselTypeId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 52);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_8_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r113);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.certificateTypeId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.certificateTypeId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r117 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 53);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_9_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r117);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.portOfCallId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.portOfCallId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r121 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 54);
    i0.ɵɵlistener("ngModelChange", function ExemptionListComponent_ng_template_32_ng_template_12_app_control_10_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r121);
      const dataItem_r66 = i0.ɵɵnextContext().dataItem;
      return i0.ɵɵresetView(dataItem_r66.vesselId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r66 = i0.ɵɵnextContext().dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r66.vesselId)("entity", dataItem_r66);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_app_control_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-control", 55);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ExemptionListComponent_ng_template_32_ng_template_12_app_control_0_Template, 1, 2, "app-control", 32);
    i0.ɵɵtemplate(1, ExemptionListComponent_ng_template_32_ng_template_12_app_control_1_Template, 1, 2, "app-control", 33);
    i0.ɵɵtemplate(2, ExemptionListComponent_ng_template_32_ng_template_12_app_control_2_Template, 1, 2, "app-control", 34);
    i0.ɵɵtemplate(3, ExemptionListComponent_ng_template_32_ng_template_12_app_control_3_Template, 1, 2, "app-control", 35);
    i0.ɵɵtemplate(4, ExemptionListComponent_ng_template_32_ng_template_12_app_control_4_Template, 1, 2, "app-control", 36);
    i0.ɵɵtemplate(5, ExemptionListComponent_ng_template_32_ng_template_12_app_control_5_Template, 1, 2, "app-control", 37);
    i0.ɵɵtemplate(6, ExemptionListComponent_ng_template_32_ng_template_12_app_control_6_Template, 1, 2, "app-control", 38);
    i0.ɵɵtemplate(7, ExemptionListComponent_ng_template_32_ng_template_12_app_control_7_Template, 1, 2, "app-control", 39);
    i0.ɵɵtemplate(8, ExemptionListComponent_ng_template_32_ng_template_12_app_control_8_Template, 1, 2, "app-control", 40);
    i0.ɵɵtemplate(9, ExemptionListComponent_ng_template_32_ng_template_12_app_control_9_Template, 1, 2, "app-control", 41);
    i0.ɵɵtemplate(10, ExemptionListComponent_ng_template_32_ng_template_12_app_control_10_Template, 1, 2, "app-control", 42);
    i0.ɵɵtemplate(11, ExemptionListComponent_ng_template_32_ng_template_12_app_control_11_Template, 1, 0, "app-control", 43);
  }
  if (rf & 2) {
    const dataItem_r66 = ctx.dataItem;
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "CAG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "FLG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "IEX");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "LOC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "ORG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "VPE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "POC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "VTP");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "CER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "PRC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r66.typeId === "VSL");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !dataItem_r66.typeId);
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.cargoOperationTypeId, "CargoOperationType")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.countryId, "Country")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.imdgId, "Imdg")));
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.berthId, "Berth")));
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.organizationId, "Organization")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.permitTypeId, "PermitType")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.callPurposeId, "VtsCallPurpose")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.vesselTypeId, "VesselType")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.certificateTypeId, "CertificateType")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.portOfCallId, "Port")), " ");
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r123 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, dataItem_r123.vesselId, "Vessel")));
  }
}
function ExemptionListComponent_ng_template_32_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ExemptionListComponent_ng_template_32_ng_template_13_span_0_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(1, ExemptionListComponent_ng_template_32_ng_template_13_span_1_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(2, ExemptionListComponent_ng_template_32_ng_template_13_span_2_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(3, ExemptionListComponent_ng_template_32_ng_template_13_span_3_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(4, ExemptionListComponent_ng_template_32_ng_template_13_span_4_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(5, ExemptionListComponent_ng_template_32_ng_template_13_span_5_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(6, ExemptionListComponent_ng_template_32_ng_template_13_span_6_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(7, ExemptionListComponent_ng_template_32_ng_template_13_span_7_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(8, ExemptionListComponent_ng_template_32_ng_template_13_span_8_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(9, ExemptionListComponent_ng_template_32_ng_template_13_span_9_Template, 4, 6, "span", 18);
    i0.ɵɵtemplate(10, ExemptionListComponent_ng_template_32_ng_template_13_span_10_Template, 4, 6, "span", 18);
  }
  if (rf & 2) {
    const dataItem_r123 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "CAG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "FLG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "IEX");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "LOC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "ORG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "VPE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "POC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "VTP");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "CER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "PRC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", dataItem_r123.typeId === "VSL");
  }
}
function ExemptionListComponent_ng_template_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-info-button", 25);
    i0.ɵɵelementStart(1, "app-editable-grid", 26)(2, "kendo-grid-column", 27);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ExemptionListComponent_ng_template_32_ng_template_4_Template, 1, 2, "ng-template", 3);
    i0.ɵɵtemplate(5, ExemptionListComponent_ng_template_32_ng_template_5_Template, 3, 6, "ng-template", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "kendo-grid-column", 28);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, ExemptionListComponent_ng_template_32_ng_template_8_Template, 1, 3, "ng-template", 3);
    i0.ɵɵtemplate(9, ExemptionListComponent_ng_template_32_ng_template_9_Template, 1, 1, "ng-template", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "kendo-grid-column", 29);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, ExemptionListComponent_ng_template_32_ng_template_12_Template, 12, 12, "ng-template", 3);
    i0.ɵɵtemplate(13, ExemptionListComponent_ng_template_32_ng_template_13_Template, 11, 11, "ng-template", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataItem_r50 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", dataItem_r50.segments)("createParameters", ctx_r13.segmentCreateParamters)("editMode", ctx_r13.editMode)("pageable", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 7, "Type"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 9, "Validity"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(11, 11, "Name"));
  }
}
const _c0 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
export class ExemptionListComponent {
  constructor() {
    this.selectionChange = new EventEmitter();
    this.currency = environment.settings.currency;
    this.itemCreateParameters = {
      from: new Date(),
      active: true
    };
    this.segmentCreateParamters = {
      validity: true
    };
    this.yesNoOptions = [{
      label: 'Is',
      value: true
    }, {
      label: 'Is not',
      value: false
    }];
    this.canEditRow = row => row.active;
  }
  resetNames(item) {
    item.cargoOperationTypeId = item.countryId = item.imdgId = item.berthId = item.organizationId = item.permitTypeId = item.callPurposeId = item.vesselTypeId = item.certificateTypeId = item.portOfCallId = item.vesselId = null;
  }
  resetMeasure(item, property) {
    item[property] = null;
  }
  selecitonChange(selection) {
    this.selectionChange.emit(selection);
  }
}
ExemptionListComponent.ɵfac = function ExemptionListComponent_Factory(t) {
  return new (t || ExemptionListComponent)();
};
ExemptionListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: ExemptionListComponent,
  selectors: [["app-exemption-list"]],
  inputs: {
    items: "items",
    editMode: "editMode",
    selection: "selection"
  },
  outputs: {
    selectionChange: "selectionChange"
  },
  decls: 33,
  vars: 38,
  consts: [["entityName", "ExemptionItem", 3, "data", "createParameters", "editMode", "canEditRow", "pageable", "selectable", "selectBy", "selection", "canDelete", "selectionChange"], ["showSelectAll", "true", "width", "1px", 4, "ngIf"], ["field", "name", "width", "300", 3, "title"], ["kendoGridEditTemplate", ""], ["field", "invoiceDescription", "width", "300", 3, "title"], ["field", "total", "width", "150", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "percentage", "width", "150", 3, "title"], ["field", "maxPeriods", "width", "150", 3, "title"], ["field", "from", "format", "g", "width", "165", 3, "title"], ["field", "to", "format", "g", "width", "165", 3, "title"], ["field", "active", "width", "40px", 3, "title"], ["field", "deactivatedFrom", "format", "g", "width", "165", 3, "title"], ["kendoGridDetailTemplate", ""], ["showSelectAll", "true", "width", "1px"], ["property", "name", 3, "ngModel", "entity", "ngModelChange"], ["property", "invoiceDescription", 3, "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "total", 3, "ngModel", "entity", "ngModelChange"], [4, "ngIf"], ["type", "number", "property", "percentage", 3, "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "maxPeriods", 3, "ngModel", "entity", "ngModelChange"], ["property", "from", 3, "ngModel", "entity", "time", "ngModelChange"], ["property", "to", 3, "ngModel", "entity", "time", "ngModelChange"], ["type", "boolean", "size", "lg", "property", "active", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "deactivatedFrom", 3, "ngModel", "entity", "time", "ngModelChange"], ["info", "An exemption must fit all listed segments"], ["entityName", "ExemptionSegment", 3, "data", "createParameters", "editMode", "pageable"], ["field", "typeId", 3, "title"], ["field", "validity", "width", "150", 3, "title"], ["field", "", 3, "title"], ["type", "codelist", "codelist", "ExemptionType", "property", "typeId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "property", "validity", 3, "options", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "CargoOperationType", "property", "cargoOperationTypeId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "Imdg", "property", "imdgId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "Organization", "property", "organizationId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "PermitType", "property", "permitTypeId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "VtsCallPurpose", "property", "callPurposeId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "VesselType", "property", "vesselTypeId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "CertificateType", "property", "certificateTypeId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "portOfCallId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", 4, "ngIf"], ["type", "codelist", "codelist", "CargoOperationType", "property", "cargoOperationTypeId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Imdg", "property", "imdgId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Organization", "property", "organizationId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "PermitType", "property", "permitTypeId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VtsCallPurpose", "property", "callPurposeId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselType", "property", "vesselTypeId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "CertificateType", "property", "certificateTypeId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "portOfCallId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "ngModel", "entity", "ngModelChange"], ["type", "codelist"]],
  template: function ExemptionListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "app-editable-grid", 0);
      i0.ɵɵlistener("selectionChange", function ExemptionListComponent_Template_app_editable_grid_selectionChange_0_listener($event) {
        return ctx.selection = $event;
      })("selectionChange", function ExemptionListComponent_Template_app_editable_grid_selectionChange_0_listener($event) {
        return ctx.selecitonChange($event);
      });
      i0.ɵɵtemplate(1, ExemptionListComponent_kendo_grid_checkbox_column_1_Template, 1, 0, "kendo-grid-checkbox-column", 1);
      i0.ɵɵelementStart(2, "kendo-grid-column", 2);
      i0.ɵɵpipe(3, "translate");
      i0.ɵɵtemplate(4, ExemptionListComponent_ng_template_4_Template, 1, 2, "ng-template", 3);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(5, "kendo-grid-column", 4);
      i0.ɵɵpipe(6, "translate");
      i0.ɵɵtemplate(7, ExemptionListComponent_ng_template_7_Template, 1, 2, "ng-template", 3);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(8, "kendo-grid-column", 5);
      i0.ɵɵpipe(9, "translate");
      i0.ɵɵtemplate(10, ExemptionListComponent_ng_template_10_Template, 1, 2, "ng-template", 3);
      i0.ɵɵtemplate(11, ExemptionListComponent_ng_template_11_Template, 1, 1, "ng-template", 6);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(12, "kendo-grid-column", 7);
      i0.ɵɵpipe(13, "translate");
      i0.ɵɵtemplate(14, ExemptionListComponent_ng_template_14_Template, 1, 2, "ng-template", 3);
      i0.ɵɵtemplate(15, ExemptionListComponent_ng_template_15_Template, 1, 1, "ng-template", 6);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(16, "kendo-grid-column", 8);
      i0.ɵɵpipe(17, "translate");
      i0.ɵɵtemplate(18, ExemptionListComponent_ng_template_18_Template, 1, 2, "ng-template", 3);
      i0.ɵɵtemplate(19, ExemptionListComponent_ng_template_19_Template, 1, 1, "ng-template", 6);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(20, "kendo-grid-column", 9);
      i0.ɵɵpipe(21, "translate");
      i0.ɵɵtemplate(22, ExemptionListComponent_ng_template_22_Template, 1, 3, "ng-template", 3);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(23, "kendo-grid-column", 10);
      i0.ɵɵpipe(24, "translate");
      i0.ɵɵtemplate(25, ExemptionListComponent_ng_template_25_Template, 1, 3, "ng-template", 3);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(26, "kendo-grid-column", 11);
      i0.ɵɵpipe(27, "translate");
      i0.ɵɵtemplate(28, ExemptionListComponent_ng_template_28_Template, 1, 3, "ng-template", 6);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(29, "kendo-grid-column", 12);
      i0.ɵɵpipe(30, "translate");
      i0.ɵɵtemplate(31, ExemptionListComponent_ng_template_31_Template, 1, 3, "ng-template", 3);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(32, ExemptionListComponent_ng_template_32_Template, 14, 13, "ng-template", 13);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("data", ctx.items)("createParameters", ctx.itemCreateParameters)("editMode", ctx.editMode)("canEditRow", ctx.canEditRow.bind(ctx))("pageable", false)("selectable", i0.ɵɵpureFunction0(37, _c0))("selectBy", "id")("selection", ctx.selection)("canDelete", false);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", !ctx.editMode);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 19, "Exemption Item Name"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(6, 21, "Invoice Description"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 23, "Total Amount"));
      i0.ɵɵadvance(4);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(13, 25, "Percentage"));
      i0.ɵɵadvance(4);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(17, 27, "Max Periods Billed"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(21, 29, "Valid From"));
      i0.ɵɵadvance(3);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(24, 31, "Valid To"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(27, 33, "Active"));
      i0.ɵɵadvance(3);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(30, 35, "Deactivated From"));
    }
  },
  dependencies: [i1.NgIf, i2.NgControlStatus, i2.NgModel, i3.ColumnComponent, i3.DetailTemplateDirective, i3.CheckboxColumnComponent, i3.CellTemplateDirective, i3.EditTemplateDirective, i4.AppControlComponent, i5.EditableGridComponent, i6.InfoButtonComponent, i1.AsyncPipe, i1.DecimalPipe, i7.TranslatePipe, i8.CodelistPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});